module.exports = __webpack_public_path__ + "static/media/new-highlight-diamond.edf0163a.svg";